import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Radio from '@mui/material/Radio';
import Typography from '@mui/material/Typography';
import thumb from '../../../images/people/picthumb1.png';
import { EventListData } from './EventListTable';
import ThinCircleIcon from '../../shared/ThinCircleIcon';
import DotCircleIcon from '../../shared/DotCircleIcon';

interface EventListDataRowProps {
    data: EventListData;
}

function formatAMPM(date: Date): string { // This is to display 12 hour format like you asked
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const minutesString = minutes < 10 ? '0' + minutes : minutes;
    const strTime = hours + ':' + minutesString + ampm;
    return strTime;
}

export default function EventListRow({ data }: EventListDataRowProps) {

    return (
        <Stack direction="row" spacing={0} sx={{ alignItems: 'center', mt: 2, mb: 2 }}>

            <Stack direction="row" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flex: '1 0 15%', ml: 0 }}>
                <Radio
                    sx={{
                        ml: 0
                    }}
                    icon={<ThinCircleIcon viewBox="0 0 40 55" sx={{ width: 30, height: 30, color: 'secondary.main' }} />}
                    checkedIcon={<DotCircleIcon viewBox="0 0 30 30" sx={{ width: 30, height: 30, color: 'secondary.main', ml: '-2px' }} />}
                />

                <Stack direction="row" >
                    <img alt="person" src={thumb} height="64" width="64" />
                    <img alt="person" src={thumb} height="64" width="64" />
                </Stack>
            </Stack>


            <Box sx={{ flex: '1 0 15%' }}>
                <Typography sx={{ color: 'text.primary', textAlign: 'center' }}>{data.mathConfidence}</Typography>
            </Box>

            <Box sx={{ flex: '1 0 15%' }}>
                <Typography sx={{ color: 'text.primary', textAlign: 'center' }}>{data.cameraStation}</Typography>
            </Box>

            <Box sx={{ flex: '1 0 15%' }}>
                <Typography sx={{ color: 'text.primary', textAlign: 'center' }}>{data.eventLocation}</Typography>
            </Box>

            <Box sx={{ flex: '1 0 15%' }}>
                <Typography sx={{
                    borderRadius: 4,
                    backgroundColor: 'info.main',
                    color: 'white',
                    fontWeight: 'bold',
                    display: 'block',
                    padding: '5px 5px 5px 5px',
                    textAlign: 'center',
                    ml: 'auto',
                    mr: 'auto',
                    fontSize: 18 

                }} >{data.tags}</Typography>
                
            </Box>

            <Box sx={{ flex: '1 0 20%' }}>
                <Typography sx={{ color: 'text.primary', textAlign: 'center' }}>{formatAMPM(data.eventDateTime)} &nbsp; {data.eventDateTime.toLocaleDateString()}</Typography>
            </Box>

        </Stack>
    )

}
